<div class="registration-footer">
  <div class="text-lg-start">
    <div class="container p-2 col-120 px-xl-0 order-last order-lg-first">
      <div class="row">
        <div class="p-2 col-120 col-lg-70">
          <p class="mb-1 text-center text-lg-start">
          ©{{year}} {{'registration.footer.company' | translate }}
          </p>
          <div class="text-center text-lg-start">
            {{'registration.footer.recaptcha.info' | translate }}
            <a target="_blank" href="{{'registration.footer.recaptcha.privacyPolicyUrl' | translate }}">{{'registration.footer.recaptcha.privacyPolicy' | translate }}</a>
              {{'generic.and' | translate }}
            <a target="_blank" href="{{'registration.footer.recaptcha.termsUrl' | translate }}">{{'registration.footer.recaptcha.terms' | translate }}</a> 
          </div>
        </div>
        <div class="p-2 col-120 col-lg-50 order-first order-lg-last">
          <div
            class="d-flex flex-column justify-content-center flex-lg-row justify-content-lg-end gap-2 gap-lg-4 text-center text-lg-start">
            <a href="{{'registration.footer.kaercher.termsUrl' | translate }}" class="m-0">{{'registration.footer.kaercher.terms' | translate }}</a>
            <a href="{{'registration.footer.kaercher.privacyUrl' | translate }}" class="m-0">{{'registration.footer.kaercher.privacy' | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
